import { render, staticRenderFns } from "./ProductForFriend.vue?vue&type=template&id=6b50fd82&scoped=true"
import script from "./ProductForFriend.vue?vue&type=script&lang=js"
export * from "./ProductForFriend.vue?vue&type=script&lang=js"
import style0 from "./ProductForFriend.vue?vue&type=style&index=0&id=6b50fd82&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b50fd82",
  null
  
)

export default component.exports